export const DEFAULT_PAYMENT_CARD_COPY = {
  buttonLabel: {
    en: 'Tip your guide',
    ee: 'Jäta giidile jootraha',
  },
  title: {
    en: 'Tip your guide',
    ee: 'Jäta giidile jootraha',
  },
  intro: {
    en: 'You enjoyed your tour? Or just wanna hug this guy, send us a tip! None of it goes to charity.',
    ee: 'Kui tuur meeldis või tahad lihtsalt giidile tänu avaldada, saada tipp otse talle. Mitte sentigi ei lähe heategevusse.',
  },
  closeLabel: {
    en: 'Cancel',
    ee: 'Sulge',
  },
};
